/* eslint-disable no-undef */
// import "@justinribeiro/lite-youtube"
import "lite-youtube-embed/src/lite-yt-embed.css"
import "lite-youtube-embed/src/lite-yt-embed.js"
import "lite-youtube-embed"
import "@szhsin/react-menu/dist/index.css"
import React from "react"
import SimpleLocalize from "./src/components/SimpleLocalize"
export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}
// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <SimpleLocalize {...props}>{element}</SimpleLocalize>
}
